export class FrameworkControlSaveModel {
    name: string | undefined;
    description: string | undefined;
    categoryId: string | undefined;
    customId: string | undefined;
    coordinatorId: string | undefined;
    tagIds: Array<string>;
    implementationGroup: string | undefined;

    constructor(
        name: string | undefined,
        description: string | undefined,
        categoryId: string | undefined,
        customId: string | undefined,
        coordinatorId: string | undefined,
        tagIds: Array<string>,
        implementationGroup: string | undefined
    ) {
        this.name = name;
        this.description = description;
        this.categoryId = categoryId;
        this.customId = customId;
        this.coordinatorId = coordinatorId;
        this.tagIds = tagIds;
        this.implementationGroup = implementationGroup;
    }

    withUpdates(updates: Partial<FrameworkControlSaveModel>): FrameworkControlSaveModel {
        return new FrameworkControlSaveModel(
            updates.name ?? this.name,
            updates.description ?? this.description,
            updates.categoryId ?? this.categoryId,
            updates.customId ?? this.customId,
            updates.coordinatorId ?? this.coordinatorId,
            updates.tagIds ?? this.tagIds,
            updates.implementationGroup ?? this.implementationGroup
        );
    }
}
